import Vue from "vue";
export function listenKeyDown(e){
    Vue.prototype.$bus.$emit("handle-key-down", e);
}
export function listenKeyUp(e){
    Vue.prototype.$bus.$emit("handle-key-up", e);
}
//用户是不是正在按着Ctrl键
export function isCtrlDown(keyDownFlag){
    return keyDownFlag[17] === true;
}
export function isShiftDown(keyDownFlag){
    return keyDownFlag[16] === true;
}
export function isAltDown(keyDownFlag){
    return keyDownFlag[18] === true;
}
export function isCopy(keyDownFlag){
    return isCtrlDown(keyDownFlag) && keyDownFlag[67] === true
}
export function isPaste(keyDownFlag){
    return isCtrlDown(keyDownFlag) && keyDownFlag[86] === true
}
export function isUnDo(keyDownFlag){
    return isCtrlDown(keyDownFlag) && keyDownFlag[90] === true
}
export function isLeftArrowDown(keyDownFlag){
    return keyDownFlag[37] === true;
}
export function isRightArrowDown(keyDownFlag){
    return keyDownFlag[39] === true;
}
export function isUpArrowDown(keyDownFlag){
    return keyDownFlag[38] === true;
}
export function isDownArrowDown(keyDownFlag){
    return keyDownFlag[40] === true;
}
export function isDeleteDown(keyDownFlag){
    return keyDownFlag[46] === true;
}